// Vietnamese (vi) translations for the paywall + checkout mini-localization
// project. Mirrors the key structure of the English source in strings.ts.
// Tarot card names always stay in English and never appear here.

import type { StringDict } from "./strings";

export const vi: StringDict = {
  billing: {
    heading: "Dùng Moonlight bất cứ lúc nào!",
    home: "Trang chủ",
    contactUs: "Liên hệ",
    toggleMonthly: "Hàng tháng",
    toggleAnnual: "Hàng năm",
    monthUnit: "tháng",
    billedAnnually: "thanh toán hàng năm {price}",
    subscribedThroughApple: "Đã đăng ký qua Apple",
    subscribedThroughGoogle: "Đã đăng ký qua Google Play",
    youreSubscribed: "Bạn đã đăng ký",
    renews: "Gia hạn",
    expires: "Hết hạn",
    managePlan: "Quản lý gói",
    tryItFree: "Dùng thử miễn phí",
    subscribe: "Đăng ký",
    legacyProPlan: "bạn đang dùng gói chuyên nghiệp cũ",
    extendTrialPrompt: "Muốn kéo dài thời gian dùng thử miễn phí?",
    sendANote: "Gửi tin nhắn",
    featureList: {
      unlimited: "Đọc bài tarot & trò chơi không giới hạn",
      keywords: "Từ khóa lá bài, gợi ý đọc bài cá nhân hóa và mẹo tarot",
      guidebook: "Phần cẩm nang mở rộng",
      journaling: "Viết nhật ký + hỗ trợ diễn giải",
      spreads: "Hơn 100 kiểu trải bài hoặc tự tạo kiểu riêng",
      friends: "Đọc bài cùng bạn bè",
      decks: "Bao gồm 6 bộ bài",
    },
    featuresHeading:
      "Moonlight trực quan, dễ dùng và được tạo ra cho cuộc sống thực của bạn.",
    features: {
      meaningsHeader: "Hiểu ý nghĩa lá bài",
      meaningsText:
        "Từ khóa tức thì & gợi ý cẩm nang cá nhân hóa cho mọi câu hỏi mà cuộc sống mang đến.",
      anywhereHeader: "Đọc bài mọi nơi",
      anywhereText:
        "Truy cập các kiểu trải bài tarot tuyệt đẹp trên di động hoặc web, bất cứ khi nào cảm hứng ập đến.",
      spreadsHeader: "Kiểu trải bài tùy chỉnh",
      spreadsText:
        "Chọn từ hơn 100 bố cục được thiết kế sẵn hoặc tự tạo kiểu riêng cho những câu hỏi cụ thể.",
      deckArtHeader: "Khám phá nghệ thuật bộ bài",
      deckArtText:
        "Biến đổi buổi đọc bài của bạn với nhiều phong cách bộ bài do các nghệ sĩ độc lập tạo ra.",
      friendsHeader: "Đọc bài cùng bạn bè",
      friendsText:
        "Đào sâu thực hành cá nhân hoặc mời bạn bè tham gia các buổi cộng tác trực tiếp.",
      practiceHeader: "Xây dựng thói quen hằng ngày",
      practiceText:
        "Học tarot qua các câu đố tương tác, kiểu trải bài và gợi ý viết nhật ký.",
    },
    trial: {
      extended: "dùng thử miễn phí kéo dài, không tự động tính phí",
      hourLeft: "còn 1 giờ trong bản dùng thử miễn phí",
      hoursLeft: "còn {count} giờ trong bản dùng thử miễn phí",
      dayLeft: "còn 1 ngày trong bản dùng thử miễn phí",
      daysLeft: "còn {count} ngày trong bản dùng thử miễn phí",
    },
  },
  overlay: {
    titleMonthly: "Gói Đăng Ký Moonlight Hàng Tháng",
    titleAnnual: "Gói Đăng Ký Moonlight Hàng Năm",
    autoRenews: "Tự động gia hạn cho đến khi hủy.",
    perMonth: "tháng",
    perYear: "năm",
    loadError: "Không thể tải giá. Vui lòng kiểm tra kết nối và thử lại.",
    retry: "Thử lại",
  },
  checkout: {
    processing: "Đang xử lý",
    confirm: "Xác nhận",
    payNow: "Thanh toán ngay",
    sendRequest: "Gửi yêu cầu",
    offerCode: "mã ưu đãi",
    checking: "đang kiểm tra...",
    applied: "đã áp dụng ✓",
    apply: "áp dụng",
    remove: "xóa",
    enterOfferCode: "Vui lòng nhập mã ưu đãi",
    invalidCode: "Mã không hợp lệ",
    errorValidating: "Lỗi khi kiểm tra mã. Vui lòng thử lại.",
    percentOff: "giảm {percent}%",
    amountOff: "giảm {amount}",
    codeApplied: "Đã áp dụng mã",
    oneTimeUse: " (dùng một lần)",
    recurringDiscount: " (giảm giá định kỳ)",
    validForMonth: " (có hiệu lực trong {count} tháng)",
    validForMonths: " (có hiệu lực trong {count} tháng)",
  },
  cta: {
    leftInTrial: "còn {time} trong bản dùng thử miễn phí",
    keepGuidebook: "Giữ trọn bộ cẩm nang với",
    subscriptionLink: "gói đăng ký Moonlight",
    unlockGuidebook: "Mở khóa trọn bộ cẩm nang với",
    tryGuidebook: "Dùng thử trọn bộ cẩm nang",
    hour: "1 giờ",
    hours: "{count} giờ",
    day: "1 ngày",
    days: "{count} ngày",
  },
  disclaimer: {
    securePaymentsStripe: "Thanh toán an toàn được cung cấp bởi Stripe.",
    securePayments: "Thanh toán an toàn.",
    chargedAfterConfirmed: "Bạn chỉ bị tính phí sau khi buổi hẹn được xác nhận.",
    flexibleRefunds: "Hoàn tiền linh hoạt.",
    moneyBack: "Được hoàn tiền khi hủy.",
  },
  faq: {
    q1: "Gói đăng ký của tôi bao gồm những gì?",
    a1: "Gói đăng ký của bạn bao gồm phòng tự tổ chức không giới hạn, quyền truy cập vào tất cả các bố cục trải bài, 4 bộ bài miễn phí kèm ý nghĩa, chủ đề tùy chỉnh, ghi chú gọn nhẹ, viết nhật ký, các buổi cá nhân và nhóm, cùng hỗ trợ đa nền tảng (iOS, Android & web).",
    q2: "Tôi sẽ nhận được những bộ bài tarot nào?",
    a2: "Bạn nhận được 4+ bộ bài miễn phí, bao gồm: Rider Waite Smith, Marseille, Summer of Bibliomancy và Internet Lore Tarot. Tất cả các bộ bài khác được bán riêng trong chợ của chúng tôi. Nhờ vậy mỗi nghệ sĩ đều được trả công! Bạn vẫn cần là thành viên để dùng các bộ bài của nghệ sĩ.",
    q3: "Có bản dùng thử miễn phí không?",
    a3: "Có! Chúng tôi cung cấp thời gian dùng thử miễn phí 3 ngày cho người mới. Nếu bạn muốn kéo dài thời gian dùng thử, chỉ cần <a href='mailto:support@moonlight.world'>gửi tin nhắn</a>.",
    q4: "Tôi có thể hủy gói đăng ký không?",
    a4: "Có, bạn có thể hủy bất cứ lúc nào. Gói đăng ký của bạn sẽ vẫn hoạt động cho đến hết kỳ thanh toán.",
    q5: "Tôi có thể dùng Moonlight trên điện thoại không?",
    a5: "Hoàn toàn được! Moonlight hoạt động trên cả thiết bị di động và máy tính, giúp bạn linh hoạt đọc bài ở bất cứ đâu. Chúng tôi có ứng dụng cho iOS và Android.",
    q6: "Khách của tôi có cần đăng ký để tham gia phòng không?",
    a6: "Không! Bất kỳ ai tham gia phòng của bạn với tư cách khách (bạn bè, khách hàng, v.v.) đều có thể vào miễn phí! Họ chỉ cần đăng ký nếu muốn tự đọc bài.",
    q7: "Tôi có cần đăng ký để đặt buổi đọc bài chuyên nghiệp không?",
    a7: "Không! Nếu bạn đặt lịch với các chuyên gia trên Moonlight, những buổi đó được thanh toán riêng. Gói đăng ký chỉ dùng cho các phòng tự tổ chức của chúng tôi.",
    q8: "Gói đăng ký có bao gồm phần mềm đặt lịch chuyên nghiệp không?",
    a8: "Nếu bạn là chuyên gia và muốn dùng Moonlight cho khách hàng, bạn cần đăng ký <a href='https://forms.moonlight.world/professional-application'>Tài khoản chuyên nghiệp</a>.",
  },
};
